import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';

const CorrectionPrintPage = () => {
  const { returnId } = useParams();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCorrectionPdf();
  }, [returnId]);

  const loadCorrectionPdf = async () => {
    try {
      // Pobierz PDF korekty z backendu
      const response = await api.get(`/pos/returns/${returnId}/pdf`, {
        responseType: 'blob'
      });

      // Utwórz URL dla blob
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

    } catch (err) {
      console.error('Błąd:', err);
      setError('Błąd pobierania korekty paragonu PDF');
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    // Otwórz PDF w nowym oknie i drukuj
    if (pdfUrl) {
      const printWindow = window.open(pdfUrl);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    }
  };

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `korekta_paragonu_${returnId}.pdf`;
      link.click();
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'var(--bg)'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid var(--danger)',
          borderTop: '4px solid transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ marginTop: '20px', color: 'var(--text-secondary)' }}>Generowanie korekty paragonu PDF...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        padding: '40px',
        textAlign: 'center',
        background: 'var(--bg)',
        minHeight: '100vh'
      }}>
        <div style={{
          background: 'var(--card-bg)',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          margin: '0 auto'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>❌</div>
          <h3 style={{ color: 'var(--danger)', margin: '0 0 10px' }}>Błąd</h3>
          <p style={{ color: 'var(--text-secondary)', margin: '0 0 20px' }}>{error}</p>
          <button
            onClick={() => window.close()}
            style={{
              padding: '10px 30px',
              border: '1px solid var(--text-muted)', color: 'var(--text-muted)' ,
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Zamknij
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'var(--bg)'
    }}>
      {/* Toolbar */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '15px',
        padding: '15px',
        background: 'var(--card-bg)',
        borderBottom: '1px solid var(--border)',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
      }}>
        <button
          onClick={handlePrint}
          style={{
            padding: '12px 30px',
            border: '1px solid var(--danger)', color: 'var(--danger)' ,
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          🖨️ Drukuj korektę paragonu
        </button>
        <button
          onClick={handleDownload}
          style={{
            padding: '12px 30px',
            border: '1px solid var(--info)', color: 'var(--info)' ,
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          📥 Pobierz PDF
        </button>
        <button
          onClick={() => window.close()}
          style={{
            padding: '12px 30px',
            border: '1px solid var(--text-muted)', color: 'var(--text-muted)' ,
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          ✖️ Zamknij
        </button>
      </div>

      {/* PDF Viewer */}
      <div style={{ flex: 1, padding: '20px', overflow: 'hidden' }}>
        {pdfUrl && (
          <iframe
            src={pdfUrl}
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '8px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
            title="Podgląd korekty paragonu"
          />
        )}
      </div>
    </div>
  );
};

export default CorrectionPrintPage;
